import type {Fetch} from '@sail/data';
import extractErrors from './extractErrors';

const wrappedCache = new WeakMap<Fetch, Fetch>();

export default function wrapFetchWithErrors(fetch: Fetch): Fetch {
  const wrappedFetch = wrappedCache.get(fetch);

  if (wrappedFetch) {
    return wrappedFetch;
  }

  const newWrappedFetch: Fetch = async function withErrorsFetch(...args) {
    const response = await fetch(...args);

    if (response.ok) {
      return response;
    } else {
      return extractErrors(response);
    }
  };

  wrappedCache.set(fetch, newWrappedFetch);

  return newWrappedFetch;
}
